module.exports = __webpack_public_path__ + "static/media/unicef_app_login_h.c2067020.jpg";